import type { UIMessage } from '../../types';
import { IconDownload } from '../web/icons';
import { FileTypeIcon, getFileCategory, FILE_TYPE_LABEL_KEY } from '../web/file-icons';

/**
 * 人工 IM「文件类」消息卡片:彩色类型图标 + 文件名/类型 + 下载按钮。
 * 从 WebChatPanel 抽出,web 客服与数字人客服共用(复用 dcs-web-file-* 样式)。
 * - 文件名:实时消息用原始 fileName;历史消息无原始名 → 退化为类型描述(不暴露 OSS 路径)。
 * - 签名 URL(fileUrl)未就绪时渲染为禁用态(非链接),resolveFileUrl 回填后自动变可点。
 * 图片/视频不走此处(各有缩略图 + Lightbox)。
 */
export function ImFileCard({ msg, t }: { msg: UIMessage; t: (key: string) => string }) {
  const category = getFileCategory({ mime: msg.fileMime, name: msg.fileName, key: msg.fileKey });
  const displayName = msg.fileName || t(FILE_TYPE_LABEL_KEY[category]);
  const body = (
    <>
      <FileTypeIcon category={category} size={36} class="dcs-web-file-icon" />
      <span class="dcs-web-file-name">{displayName}</span>
      <span class="dcs-web-file-download" aria-label={t('web.downloadFile')}>
        <IconDownload size={18} />
      </span>
    </>
  );
  return msg.fileUrl ? (
    <a
      class="dcs-web-file-card"
      href={msg.fileUrl}
      target="_blank"
      rel="noopener noreferrer"
      download={msg.fileName}
      title={displayName}
    >
      {body}
    </a>
  ) : (
    <span class="dcs-web-file-card is-loading" title={displayName}>
      {body}
    </span>
  );
}
